import ImportProc from './src/import';

/* istanbul ignore next */
ImportProc.install = function(Vue) {
  Vue.component(ImportProc.name, ImportProc);
};

export default ImportProc;
